import React from 'react'
import { Chip, Grid, Typography } from '@mui/material'
import {
  getStatusColor,
  getStatusColorStyles,
} from '@modules/requirements/requirements.utils'
import { getCorrectFontColor } from '@shared/utils/get-correct-font-color'
import makeStyles from '@mui/styles/makeStyles'
import { AuditRequirementResponse, Status } from '@shared/types'
import { getStatusText, StatusText } from './get-status-text'

interface Props {
  requirement: AuditRequirementResponse
  role: keyof StatusText
  title: string
  statuses: Status[]
}

export const StatusContainer = ({
  requirement,
  role,
  statuses,
  title,
}: Props) => {
  const classes = useStyles()

  const statusText = getStatusText(statuses || [], requirement)
  const statusColor = getStatusColor(
    statuses,
    role === 'auditor'
      ? requirement.auditorStatus?.statusBaseId
      : requirement.clientStatus?.statusBaseId
  )

  return (
    <Grid className={classes.statusContainer}>
      <Typography className={classes.status}>{title}</Typography>
      <Chip
        label={statusText[role]}
        style={{
          ...getStatusColorStyles(statusColor),
          ...getCorrectFontColor(statusText[role]),
        }}
      />
    </Grid>
  )
}

export const useStyles = makeStyles((theme) => ({
  statusContainer: {
    display: 'flex',
    paddingTop: 10,
    alignItems: 'center',
  },
  status: {
    color: theme.palette.grey['700'],
    fontWeight: 700,
    textTransform: 'uppercase',
    marginRight: theme.spacing(1),
  },
}))
